import { getCardCostPercentage } from '../../../constants/VisitsConstants'

export const calculateCashItemsDetails = (values, cardCost = 0) => {
  let items =
    values?.items?.filter(
      data => data?.checked == true && !data?.low_stock && !data?.out_of_stock
    ) || []
  const deductFromDeposit = values?.deduct_from_deposit || false
  const isSaudiPatient = values?.nationality?.toLowerCase() === 'saudi'
  const detailedItems = items.map(item => {
    const unitPrice =
      Number(item.unit_price) || Number(item?.approved_amount) || 0
    const quantity = Number(item.quantity) || Number(item?.approved_qty) || 0
    const discountValue = Number(item?.discount_amount) || 0
    const discountType = item?.discount_type || ''
    const daily_package_deal = item?.daily_package_deal || false
    const itemAmount = unitPrice * quantity
    const discountAmount =
      discountType === 'percentage'
        ? (itemAmount * discountValue) / 100
        : discountType === 'fixed'
        ? discountValue
        : 0
    const taxAmount = (
      values?.isEditInvoice
        ? item.tax_check
        : item.tax_check && !deductFromDeposit && !isSaudiPatient
    )
      ? CalculateTax({ values: { items: [item] } })
      : 0
    const netTotal = itemAmount - discountAmount

    return {
      unit_price: unitPrice,
      original_price: item?.original_price || unitPrice,
      number_of_sessions: item?.number_of_sessions || 0,
      quantity,
      daily_package_deal,
      item_id: item?.item_id,
      tax_check: item?.tax_check,
      item_code: item?.non_standard_code || '',
      standard_code: item?.standard_code || '',
      standard_description: item?.standard_description || '',
      item_name: item?.item_name || item?.non_standard_description,
      item_type: item?.item_type || '',
      item_category: item?.item_category || '',
      discount_amount: item?.discount_amount,
      discount_type: discountType,
      discount_value: Number(discountAmount.toFixed(2)),
      discounted_amount: Number((itemAmount - discountAmount).toFixed(2)),
      itemAmount: Number(itemAmount.toFixed(2)),
      patient_share: Number(netTotal.toFixed(2)),
      company_share: 0,
      patient_tax: Number(taxAmount.toFixed(2)),
      company_tax: 0,
      manage_costs: item?.manage_costs || []
    }
  })

  const totalAmount = detailedItems.reduce(
    (sum, item) => sum + item.itemAmount,
    0
  )
  const totalDiscount = detailedItems.reduce(
    (sum, item) => sum + item.discount_value,
    0
  )
  const totalTax = detailedItems.reduce(
    (sum, item) => sum + item.patient_tax,
    0
  )
  const netTotal = detailedItems.reduce(
    (sum, item) => sum + item.patient_share,
    0
  )
  const totalGrossAmount = detailedItems?.reduce((total, item) => {
    return total + item.quantity * item.unit_price
  }, 0)

  const netPayableAmount = Number(totalGrossAmount) - Number(totalDiscount)
  const newtotalAmount = totalAmount - totalDiscount
  return {
    itemBreakdown: detailedItems,
    totals: {
      patientShareTotal: Math.max(Number(newtotalAmount.toFixed(2)), 0),
      companyShareTotal: 0,
      patientTaxTotal: Math.max(Number(totalTax.toFixed(2)), 0),
      companyTaxTotal: 0,
      discountAmountTotal: Math.max(Number(totalDiscount.toFixed(2)), 0),
      totalAmount: Math.max(Number((newtotalAmount + totalTax).toFixed(2)), 0),
      totalGrossAmount: Math.max(totalGrossAmount, 0),
      netPayableAmount: Math.max(netPayableAmount, 0),
      ...((values?.paymentMethod === 'card' ||
        values?.paymentMethod === 'multi_payment' ||
        values?.payment_method === 'card' ||
        values?.payment_method === 'multi_payment') && {
        card_cost: getCardCostPercentage(
          cardCost,
          Math.max(Number(newtotalAmount.toFixed(2)), 0)
        )
      })
    }
  }
}

export const getInsuranceRemainingLimit = payerData => {
  const limit = payerData?.max_limit

  return Math.max(Number(limit) || 0, 0)
}

export const getApplicableInsuranceLimit = (
  payerData,
  episodeRemainingLimit = null,
  episodeMaxLimit = null,
  maxLimitOverride = null
) => {
  if (maxLimitOverride !== null && maxLimitOverride !== undefined) {
    return Math.max(Number(maxLimitOverride) || 0, 0)
  }

  const hasEpisodeLimit =
    episodeMaxLimit !== null &&
    episodeMaxLimit !== undefined &&
    (Number(episodeMaxLimit) > 0 || Number(episodeRemainingLimit) > 0)

  if (hasEpisodeLimit) {
    return Math.max(Number(episodeRemainingLimit) || 0, 0)
  }

  return getInsuranceRemainingLimit(payerData)
}

export function calculateInsuranceItemsDetails (
  values,
  maxLimit,
  patientData,
  cardCost = 0
) {
  let items =
    values?.items?.filter(
      data => data?.checked == true && !data?.low_stock && !data?.out_of_stock
    ) || []
  const normalizedMaxLimit = Math.max(Number(maxLimit) || 0, 0)
  let totalPatientShare = 0
  let totalLimitedPatientShare = 0
  let totalCompanyShare = 0

  let totalPatientTax = 0
  let totalCompanyTax = 0
  let totalDiscountedAmount = 0
  const deductFromDeposit = values?.deduct_from_deposit || false
  const isSaudiPatient = patientData?.nationality?.toLowerCase() === 'saudi'
  const isCorporateOrGovernment =
    patientData?.beneficiary_type === 'corporate' ||
    patientData?.beneficiary_type === 'government'

  const itemBreakdown = items.map(itm => {
    const unitPrice =
      Number(itm.unit_price) || Number(itm?.approved_amount) || 0

    const discount_type = itm?.discount_type
    const isVat = itm?.payer_vat ? true : !isSaudiPatient ? true : false
    const quantity = Number(itm.quantity) || Number(itm?.approved_qty) || 0
    const discountAmount = Number(itm?.discount_amount) || 0
    const daily_package_deal = itm?.daily_package_deal || false
    const isCashItem = itm?.item_category == 'cash'
    const patientSharePercentage = isCashItem
      ? 100
      : Number(itm?.patient_share) || 0

    const totalAmount = unitPrice * quantity
    let discountedAmount

    if (itm?.discount_type === 'fixed') {
      discountedAmount = totalAmount - discountAmount
      totalDiscountedAmount += discountAmount
    } else {
      const discountValue = (totalAmount * discountAmount) / 100
      totalDiscountedAmount += discountValue
      discountedAmount = totalAmount - discountValue
    }

    const fullPatientShare = (discountedAmount * patientSharePercentage) / 100
    let currentPatientShare = 0
    let currentCompanyShare = 0
    const isPatientTaxable = values?.isEditInvoice
      ? itm?.tax_check
      : itm?.tax_check && !deductFromDeposit && !isSaudiPatient

    if (isCashItem) {
      currentPatientShare = fullPatientShare
      currentCompanyShare = 0
    } else {
      if (isCorporateOrGovernment) {
        currentPatientShare = fullPatientShare
        currentCompanyShare = discountedAmount - currentPatientShare
      } else {
        if (totalLimitedPatientShare < normalizedMaxLimit) {
          const remainingLimit = normalizedMaxLimit - totalLimitedPatientShare
          const remainingPatientShareLimit = isPatientTaxable
            ? remainingLimit / 1.15
            : remainingLimit

          if (fullPatientShare <= remainingPatientShareLimit) {
            currentPatientShare = fullPatientShare
          } else {
            currentPatientShare = remainingPatientShareLimit
          }
        }
        currentCompanyShare = discountedAmount - currentPatientShare
      }
    }

    totalPatientShare += currentPatientShare
    if (!isCashItem) {
      totalLimitedPatientShare +=
        currentPatientShare +
        (isPatientTaxable ? currentPatientShare * 0.15 : 0)
    }
    totalCompanyShare += currentCompanyShare

    let patientTax = 0
    let companyTax = isVat ? currentCompanyShare * 0.15 : 0

    if (isPatientTaxable) {
      patientTax = currentPatientShare * 0.15
    }

    totalPatientTax += patientTax
    totalCompanyTax += companyTax

    return {
      item_id: itm?.item_id,
      item_code: itm?.non_standard_code || '',
      item_name: itm?.item_name || itm?.non_standard_description || '',
      item_type: itm?.item_type || '',
      item_category: itm?.item_category || '',
      tax_check: itm?.tax_check,
      daily_package_deal,
      discount_type: itm?.discount_type,
      standard_code: itm?.standard_code || '',
      standard_description: itm?.standard_description || '',
      unit_price: unitPrice,
      original_price: itm?.original_price || unitPrice,
      number_of_sessions: itm?.number_of_sessions || 0,
      quantity: Number(quantity),
      total_amount: parseFloat(totalAmount.toFixed(2)),
      discount_value: parseFloat(
        discount_type === 'percentage'
          ? (totalAmount * discountAmount) / 100
          : discount_type === 'fixed'
          ? discountAmount
          : 0
      ),
      discounted_amount: parseFloat(discountedAmount.toFixed(2)),
      discount_amount: itm?.discount_amount,
      patient_share: parseFloat(currentPatientShare.toFixed(2)),
      company_share: parseFloat(currentCompanyShare.toFixed(2)),
      patient_tax: parseFloat(patientTax.toFixed(2)),
      company_tax: parseFloat(companyTax.toFixed(2)),
      payer_vat: isVat,
      manage_costs: itm?.manage_costs || []
    }
  })

  const totalGrossAmount = itemBreakdown?.reduce((total, item) => {
    return total + item.quantity * item.unit_price
  }, 0)

  const netPayableAmount =
    Number(totalGrossAmount) - Number(totalDiscountedAmount)

  return {
    itemBreakdown,
    totals: {
      patientShareTotal: Math.max(parseFloat(totalPatientShare.toFixed(2)), 0),
      companyShareTotal: Math.max(parseFloat(totalCompanyShare.toFixed(2)), 0),
      patientTaxTotal: Math.max(parseFloat(totalPatientTax.toFixed(2)), 0),
      companyTaxTotal: Math.max(parseFloat(totalCompanyTax.toFixed(2)), 0),
      discountAmountTotal: Math.max(
        parseFloat(totalDiscountedAmount.toFixed(2)),
        0
      ),
      totalGrossAmount: Math.max(totalGrossAmount, 0),
      netPayableAmount: Math.max(netPayableAmount, 0),
      totalAmount: Math.max(
        parseFloat(totalPatientShare.toFixed(2)) +
          parseFloat(totalCompanyShare.toFixed(2)) +
          parseFloat(totalPatientTax.toFixed(2)) +
          parseFloat(totalCompanyTax.toFixed(2)),
        0
      ),
      ...((values?.paymentMethod === 'card' ||
        values?.paymentMethod === 'multi_payment' ||
        values?.payment_method === 'card' ||
        values?.payment_method === 'multi_payment') && {
        card_cost: getCardCostPercentage(
          cardCost,
          Math.max(parseFloat(totalPatientShare.toFixed(2)), 0)
        )
      })
    }
  }
}

export function CalculateTax ({ values }) {
  const items =
    values?.items?.filter(
      data => data?.checked == true || data?.tax_check == true
    ) || []
  const taxableAmount = items
    .filter(itm => itm?.tax_check)
    .map(itm => {
      const unitPrice = Number(itm?.unit_price) || 0
      const quantity = Number(itm?.quantity) || 0
      return unitPrice * quantity
    })
    .reduce((acc, curr) => acc + curr, 0)

  const totalDiscount = items
    .filter(itm => itm?.tax_check)
    .map(itm => {
      const discountAmount = Number(itm?.discount_amount) || 0
      const discountType = itm?.discount_type
      let discount = 0

      if (discountType === 'percentage') {
        discount =
          (Number(itm.unit_price) * Number(itm.quantity) * discountAmount) / 100
      } else if (discountType === 'fixed') {
        discount = discountAmount
      }

      return discount
    })
    .reduce((acc, curr) => acc + curr, 0)

  const taxableAmountAfterDiscount = Math.max(taxableAmount - totalDiscount, 0)

  const taxAmount = (taxableAmountAfterDiscount * 15) / 100
  return taxAmount
}
